import { render, staticRenderFns } from "./IconLangEn.vue?vue&type=template&id=1d76e165"
import script from "./IconLangEn.vue?vue&type=script&lang=js"
export * from "./IconLangEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports